import React from "react";
import Image from "../../../components/image";

const ProviderBiography = ({
  providerBiography,
  layout = "ingo",
  bioSubHeadingClass = "sm:flex pb-1 text-xs font-normal text-gray-nonary course-intro",
  bioExperienceClass = "pb-5 md:pt-3 text-gray-nonary",
  containerClass = "border-t border-gray-standard md:border-black-quaternary",
  containerInnerClass = "pt-10 pb-3 sm:pb-5",
  contentClass = "pl-5 md:pl-8",
  imgContainerClass = "rounded-full border border-gray-dark sm:h-24 w-24",
  imgClass = "w-full rounded-full p-1"
}) => {
  return (
    <>
      <section className={`w-full mr-auto tab-content ${containerClass}`}>
        <div
          className={`flex space-between items-center ${containerInnerClass}`}
        >
          <div className={`flex avatar-icon ${imgContainerClass}`}>
            <Image
              imageAlt={"avatar-icon"}
              image={providerBiography?.avatar}
              imageClass={`row-span-1 col-span-2 sm:col-span-1 object-cover object-center ${imgClass}`}
              sourceUrl={providerBiography?.avatar}
            />
          </div>
          <div className={`flex flex-col space-between ${contentClass}`}>
            <div
              className="block pb-1 font-light text-black-lighter planet:font-bold text-xl sm:text-xlrg-sm planet:text-gray-dark "
              dangerouslySetInnerHTML={{
                __html: [
                  `${layout === "ingo" ? "Meet your program manager," : ""}`,
                  providerBiography?.name
                ].join(" ")
              }}
            />
            <div
              className={bioSubHeadingClass}
              dangerouslySetInnerHTML={{
                __html: `${layout === "ingo" ? 'Verified by <span class="text-black-lighter planet:text-gray-dark pl-1 tab-content_html">GVI</span' : providerBiography?.desc}`
              }}
            />
            {providerBiography?.experience && layout === "journeys" && (
              <div
                className={bioExperienceClass}
                dangerouslySetInnerHTML={{
                  __html: providerBiography?.experience
                }}
              />
            )}
          </div>
        </div>

        {providerBiography?.desc && layout === "ingo" && (
          <div
            className={bioExperienceClass}
            dangerouslySetInnerHTML={{
              __html: providerBiography?.desc
            }}
          />
        )}
      </section>
    </>
  );
};

export default ProviderBiography;
